// removed by extract-text-webpack-plugin
module.exports = {"button":"___Button__button___1dTnN","shadow":"___Button__shadow___2HpcJ","primary":"___Button__primary___2SD73","secondary":"___Button__secondary___3CXeD","warn":"___Button__warn___la6Pr","inactive":"___Button__inactive___1PlFa"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Button/Button.less
// module id = 553
// module chunks = 0